export default "__VITE_ASSET__FCmRH9mx__"